import React, { useEffect, useRef, useState } from 'react'
import CourseSelection from './CourseSelection'
import CustomerForm from './CustomerForm'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import PaymentSection from './PaymentSection'
import Loader from '../../common/Loader'
import { axiosInstance } from '../config'
import { config } from '../config'
import secureLocalStorage from 'react-secure-storage'
import SlotSelection from './SlotSelection'
import InstructorSelection from './InstructorSelection'
import moment from 'moment'
import { getSlots } from './CalculateDays'
import swal from 'sweetalert'
import UserIcon from "../../../assets/images/user.webp"

const BookingProcess = () => {

    const [isFromCourse, setIsFromCourse] = useState(false)
    const [timeSlot, setTimeSlot] = useState({
        date: moment().format("YYYY-MM-DD"),
        time: ''
    })

    // for slots tab
    const [slotsdata, setSlots] = useState([]);
    const [InstructorCourse, setInstructorCourse] = useState([]);

    const location = useLocation();
    const courseData = location.state?.courseData;

    useEffect(() => {
        if (courseData) {
            setSelectedCourse(courseData);
            setCarType(courseData?.cartype)
            setIsFromCourse(true)
        }
    }, [courseData])

    useEffect(() => {
        // data persistence
        const persistData = secureLocalStorage.getItem('temp_details')
        if (persistData) {
            setSelectedCourse(persistData?.selected_course)
            setStep(persistData?.step)
            setcode(persistData?.code)
            setdiscount(persistData?.discount)
            setCustomerData(persistData?.customer_data)
            setCarType(persistData?.selected_course?.cartype)
            setTimeSlot(persistData?.timeSlot)
            setSelectedInstructor(persistData?.selected_instructor)
        }

    }, [])


    const Navigate = useNavigate();
    const [selected_course, setSelectedCourse] = useState('')
    const [selected_instructor, setSelectedInstructor] = useState({})

    const [provisional_licence, setProvisionalLicence] = useState('')
    const [car_type, setCarType] = useState('')

    const [customer_data, setCustomerData] = useState('')

    const [errors, setErrors] = useState('')

    const [step, setStep] = useState(1)

    const divRef = useRef(null);

    const [course_types, setCourse] = useState([]);
    const [loading, setLoading] = useState(false);

    const [Price, setPrice] = useState("");
    const [discount, setdiscount] = useState('')

    const [code, setcode] = useState('')

    useEffect(() => {
        if (selected_instructor?.id)
            getSessionsInfo();
    }, [selected_instructor]);

    const getSessionsInfo = () => {
        setLoading(true);
        axiosInstance
            .get(`get-instlesson_slots/${selected_instructor?.id}`)
            .then((res) => {
                const lessons = res?.data?.data.filter((item) => item?.instacceptance !== "1") || [];
                setInstructorCourse(lessons);
                const activeDays = res?.data?.slots?.filter(s => s.status == 0);
                const fullWeekData = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {
                    const existingSlot = activeDays?.find(slot => slot.days === day);
                    if (existingSlot) {
                        return existingSlot;  // If there's a slot for this day, keep the existing slot
                    } else {
                        return {
                            id: null,  // If no slot exists, set id to null
                            instructorid: selected_instructor?.id,
                            days: day,
                            slots: "[]",  // Empty array for slots
                            status: "1"
                        };
                    }
                });
                console.log(fullWeekData)
                setSlots(fullWeekData)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        setLoading(true)

        axiosInstance.get(`get-cources`)
            .then(res => {
                // console.log(res.data)
                setCourse(res.data.cources
                    .filter(course => course.status === 0)  // Filter out courses with status equal to 1
                    .reverse()
                )
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        setPrice(selected_course?.price);
    }, [selected_course?.price])

    useEffect(() => {
        // Calculate the discount amount
        const discountAmount = (Price * discount) / 100;
        // Calculate the new price by subtracting the discount amount from the original price
        const NewPrice = Price - discountAmount;

        // Set the new price after discount
        setPrice(NewPrice);
    }, [discount]);


    // validations errors
    const validation1 = () => {
        const newErrors = {};

        if (!car_type) {
            newErrors.car_type = 'Car type is required';
        }

        if (!selected_course) {
            newErrors.selected_course = 'Course type is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateCustomerData = () => {
        const newErrors = {};

        // Destructure customer data fields
        const { fname, email, phone, address, postalcode } = customer_data;

        // Validate Full Name
        if (!fname || fname.trim() === '') {
            newErrors.fname = 'Full name is required';
        }

        // Validate Email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            newErrors.email = 'Email is required';
        } else if (!emailRegex.test(email)) {
            newErrors.email = 'Invalid email format';
        }

        // Validate Phone
        const phoneRegex = /^[0-9]{10}$/; // Adjust regex based on your country format
        if (!phone) {
            newErrors.phone = 'Phone number is required';
        } else {
            // Remove the country code and hyphen, only validate the number part
            const phoneNumber = phone.replace('+44-', '');

            // Validate the length of the phone number (after removing +44-)
            if (phoneNumber.length !== 10) {
                newErrors.phone = 'Phone number must be exactly 10 digits';
            } else if (!phoneRegex.test(phoneNumber)) {
                newErrors.phone = 'Invalid Phone number length';
            }
        }

        // Validate Address
        if (!address || address.trim() === '') {
            newErrors.address = 'Address is required';
        }

        // Validate Postal Code
        if (!postalcode) {
            newErrors.postalcode = 'Postal code is required';
        } else if (postalcode.length < 6 || postalcode.length > 10) {
            newErrors.postalcode = 'Postal code must be between 6 and 10 characters';
        }

        // Set errors and retur
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ====================================
    // makePaymentRequest
    const makePaymentRequest = async (data) => {
        const { url, parameters } = data;

        const params = {
            storename: parameters.storename,
            timezone: parameters.timezone,
            txntype: parameters.txntype,
            chargetotal: parameters.chargetotal,
            currency: parameters.currency,
            txndatetime: parameters.txndatetime,
            hashExtended: parameters.hashExtended,
            hash_algorithm: parameters.hash_algorithm,
            checkoutoption: parameters.checkoutoption,
            responseFailURL: parameters.responseFailURL,
            responseSuccessURL: parameters.responseSuccessURL,
        }

        try {
            // Dynamically create and submit the form after the component mounts
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;  // Netwest Gateway URL

            // Add all the parameters to the form
            Object.keys(params).forEach((key) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = params[key];
                form.appendChild(input);
            });

            // Append form to the body and submit
            document.body.appendChild(form);
            form.submit();

            // return payment
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const changeStep = async (e) => {
        e.preventDefault();

        const { offsetTop } = divRef.current
        window.scrollTo({ top: offsetTop - 40, behavior: 'instant' })

        if (step === 1 && validateCustomerData()) {

            try {
                setLoading(true)

                const response = await axiosInstance.post("check-email", { email: customer_data?.email });

                if (response?.data?.success === true && response?.data?.message == "User with this email already exists") {
                    toast.error("Email Already Taken , Please use diffrent email");
                    return;
                }
            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }

        if (step === 2 && !validation1()) {
            return;
        }

        if (step === 3 && !selected_instructor?.id) {
            swal('', 'Please choose any instructor !', 'warning')
            return;
        }

        if (step === 4 && !timeSlot?.time) {
            swal('', 'Please select time slot !', 'warning')
            return;
        }

        if (step === 5 && validateCustomerData()) {

            try {
                const Slots = JSON.stringify(getSlots(selected_course, timeSlot?.date, timeSlot?.time));

                setLoading(true)
                const formData = new FormData()

                formData.append("name", customer_data.fname)
                formData.append("email", customer_data.email)
                formData.append("phone_number", customer_data.phone)
                formData.append("address", customer_data.address)
                formData.append("pincode", customer_data.postalcode)
                formData.append("course_id", selected_course?.id)
                formData.append("cartype", car_type)
                formData.append("promocode", (discount) ? code : null);
                formData.append("prolicence", 'Yes')
                formData.append("instructorid", selected_instructor?.id)
                formData.append("bookingdate", timeSlot?.date)
                formData.append("bookingtime", timeSlot?.time)
                formData.append("slots", Slots);


                // instructorid, bookingdate, bookingtime, slots

                // for data persistent
                secureLocalStorage.setItem('temp_details', {
                    customer_data,
                    selected_course,
                    step,
                    code,
                    discount,
                    timeSlot,
                    selected_instructor
                })

                const res = await axiosInstance.post(`enrollment/payment`, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                })

                if (res.data.url) {
                    const paymentRes = await makePaymentRequest(res.data)

                }


                // if (res.data.success == false && res.data.message == 'Email already registered, Please use another one') {
                //     toast.error('This Email already taken !');
                //     setLoading(false);
                //     return
                // }

                // if (res.data.success == true && res.data.message == 'New User and lesson created successfully') {
                //     toast.success('Booking Completed , Login with Email ID and Password');
                //     setLoading(false);
                //     setStep(1)
                //     Navigate(`${config.appUrl}`);
                //     return
                // }


            } catch (error) {
                console.log(error)
                toast.error('Something went wrong !');
                setLoading(false)
            }

            // try {
            //     setLoading(true)
            //     const formData = new FormData()
            //     formData.append("courceid", selected_course?.id)
            //     formData.append("cartype", car_type)
            //     formData.append("name", customer_data.fname)
            //     formData.append("email", customer_data.email)
            //     formData.append("mobile", customer_data.phone)
            //     formData.append("address", customer_data.address)
            //     formData.append("pincode", customer_data.postalcode)
            //     formData.append("updated_price", Price);

            //     const res = await axiosInstance.post(`add-lessons`, formData, {
            //         headers: {
            //             Accept: "application/json",
            //             "Content-Type": "multipart/form-data",
            //         }
            //     })

            //     if (res.data.success == false && res.data.message == 'Email already registered, Please use another one') {
            //         toast.error('This Email already taken !');
            //         setLoading(false);
            //         return
            //     }

            //     if (res.data.success == true && res.data.message == 'New User and lesson created successfully') {
            //         toast.success('Booking Completed , Login with Email ID and Password');
            //         setLoading(false);
            //         setStep(1)
            //         Navigate(`${config.appUrl}`);
            //         return
            //     }


            // } catch (error) {
            //     console.log(error)
            //     toast.error('Something went wrong !');
            //     setLoading(false)
            // }
        }

        // main logic
        if (step > 0 && step < 5) {
            if (selected_course && isFromCourse && step < 3) {
                setStep(3);
            }
            else if (validateCustomerData()) {
                setStep(prev => prev + 1)
            }
        }

    }

    // promo code apply

    const CheckCode = async () => {
        if (code !== '') {
            setLoading(true);
            try {
                const res = await axiosInstance.post("check-code", {
                    email: customer_data.email,
                    codename: code
                })

                if (res?.data?.success === false && res?.data?.message == "Promo code is not applied for existing user") {
                    toast.error("Promo Code Only Available for New Users");
                    return;
                }

                if (res?.data?.success === true) {
                    setdiscount(res?.data?.data?.discount);
                    toast.success("Promo Code Applied");
                }
                if (res?.data?.success === false) {
                    toast.error("No Promo Code Available");
                }

            } catch (Error) {
                console.log("Error", Error);
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Please add Promo Code to Apply");
        }
    }

    return (
        <>
            {loading && <Loader />}
            <div className='py-5' ref={divRef}>
                <div className="auto-container py-md-4">
                    <div className='booking_box'>
                        <div className="row">
                            <div className="col-md-9">
                                <div>
                                    <p className='text-danger'>Are you an existing student? If so, please
                                        <a href={config.StudentUrl} target='_blank' className='text-dark fw-semibold'> Login </a>
                                        to your account to make a booking.</p>
                                </div>
                                <form onSubmit={changeStep}>

                                    {
                                        step === 1 &&
                                        <CustomerForm
                                            customer_data={customer_data}
                                            setCustomerData={setCustomerData}
                                            errors={errors}
                                        />
                                    }

                                    {
                                        step === 2 &&
                                        // step 2 
                                        <CourseSelection
                                            course_types={course_types}
                                            selectedCource={selected_course}
                                            setSelectedCourse={setSelectedCourse}
                                            setCarType={setCarType}
                                            errors={errors}
                                            setSelectedInstructor={setSelectedInstructor}
                                            cartype={car_type}
                                            Course={selected_course}
                                        />
                                    }
                                    {
                                        step === 3 &&
                                        // step 3
                                        <InstructorSelection
                                            instructors={selected_course?.instructors?.filter(i => (i.status == 0 && i.trash == 0))}
                                            selected_instructor={selected_instructor}
                                            setSelectedInstructor={setSelectedInstructor}
                                            setTimeSlot={setTimeSlot}
                                        />
                                    }

                                    {
                                        step === 4 &&
                                        <SlotSelection
                                            timeSlot={timeSlot}
                                            setTimeSlot={setTimeSlot}
                                            id={selected_instructor?.id}
                                            slotsdata={slotsdata}
                                            InstructorCourse={InstructorCourse}
                                            selectedCource={selected_course}
                                        />
                                    }

                                    {
                                        step === 5 &&
                                        <PaymentSection
                                            selected_course={selected_course}
                                            price={Price}
                                            setdiscount={setdiscount}
                                            setPrice={setPrice}
                                            setstep={setStep}
                                            code={code}
                                            setcode={setcode}
                                            CheckCode={CheckCode}
                                            loading={loading}
                                            isFromCourse={isFromCourse}
                                        />
                                    }
                                    {
                                        step !== 5 &&
                                        <div className='d-flex justify-content-between flex-md-row flex-column-reverse mt-5'>
                                            {step > 1 && step <= 5 && (
                                                <div>
                                                    <div className="btn-box text-center mt-3">
                                                        <button className="theme-btn btn-two" type='button'
                                                            onClick={() => {
                                                                setStep(step - 1);
                                                            }} >
                                                            <i className='bi bi-arrow-left me-2 fs-6'></i>
                                                            Back
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="btn-box text-center mt-3">
                                                <button className="theme-btn btn-two" type='submit' >
                                                    Save & Next
                                                    <i className='bi bi-arrow-right ms-2 fs-6'></i>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                            <div className="col-md-3 mt-md-0 mt-5">
                                <div className='input-white-box d-block px-3'>
                                    <h5 className='mb-2 fw-semibold text-green'>Need Help?</h5>
                                    <p>If you have any questions, please call us on <br /> <a href="tel:0116 210 2688" className='Booking-link'>0116 210 2688</a> <br /> <a href="tel:+44 7380 851496" className='Booking-link'>+44 7380 851496</a></p>
                                </div>
                                <div className='input-white-box d-block px-3'>
                                    <h5 className='mb-3 fw-semibold text-green'>Booking Summary</h5>

                                    {
                                        selected_course?.id ?
                                            <div>
                                                <h6 className='mb-2'>Course Name</h6>
                                                <p>{selected_course?.title}</p>
                                                <h6 className='my-2'>Price</h6>
                                                <p>£ {Price} </p>
                                            </div> : <p>Not Available..</p>
                                    }
                                </div>
                                <div className='input-white-box d-block px-3'>
                                    <h5 className='mb-3 fw-semibold text-green'>Instructor</h5>
                                    {
                                        selected_instructor?.id ?
                                            <div className='d-flex align-items-center'>
                                                <div>
                                                    <img src={selected_instructor?.image ? `${config.imageUrl}${selected_instructor?.image}` : UserIcon} alt="" />
                                                </div>
                                                <div className='ms-2'>
                                                    <h6 className='mb-1'>{selected_instructor?.name}</h6>

                                                    <p>{selected_instructor?.location}</p>
                                                </div>
                                            </div> : <p>You haven't selected any instructor..</p>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default BookingProcess